import type {HomeDashboardRecentChange} from '../../reports/reports.models';

type RecentChangePathOptions = {
  separator?: string;
};

export function buildRecentChangePathText(
  change: Pick<HomeDashboardRecentChange, 'entityType' | 'path' | 'containerLabel' | 'locationLabel'>,
  options: RecentChangePathOptions = {},
): string {
  const separator = options.separator ?? '/';
  const pathSegments = change.entityType === 'Container' ? change.path.slice(0, -1) : change.path;

  if (pathSegments.length > 0) {
    return pathSegments.map((segment) => segment.name).join(separator);
  }

  if (change.entityType === 'Container') {
    return '';
  }

  return change.containerLabel ?? change.locationLabel ?? change.entityType;
}
